// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/report_account.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/report_account.proto.
 */
export const file_accounts_report_account: GenFile = /*@__PURE__*/
  fileDesc("Ch1hY2NvdW50cy9yZXBvcnRfYWNjb3VudC5wcm90bxIPcHJvdG9zLmFjY291bnRzIrkBChRSZXBvcnRBY2NvdW50UmVxdWVzdBI8CgZwYXJhbXMYASABKAsyLC5wcm90b3MuYWNjb3VudHMuUmVwb3J0QWNjb3VudFJlcXVlc3QuUGFyYW1zGmMKBlBhcmFtcxISCgphY2NvdW50X2lkGAEgASgJEjQKBnJlYXNvbhgCIAEoDjIkLnByb3Rvcy5hY2NvdW50cy5SZXBvcnRBY2NvdW50UmVhc29uEg8KB21lc3NhZ2UYAyABKAkiYAoVUmVwb3J0QWNjb3VudFJlc3BvbnNlEj0KBnJlc3VsdBgBIAEoCzItLnByb3Rvcy5hY2NvdW50cy5SZXBvcnRBY2NvdW50UmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdCrxAgoTUmVwb3J0QWNjb3VudFJlYXNvbhIhCh1SRVBPUlRfQUNDT1VOVF9SRUFTT05fVU5LTk9XThAAEicKI1JFUE9SVF9BQ0NPVU5UX1JFQVNPTl9JTVBFUlNPTkFUSU9OEAESIQodUkVQT1JUX0FDQ09VTlRfUkVBU09OX0RJU0xJS0UQAhIeChpSRVBPUlRfQUNDT1VOVF9SRUFTT05fU1BBTRADEiAKHFJFUE9SVF9BQ0NPVU5UX1JFQVNPTl9TRVhVQUwQBBIeChpSRVBPUlRfQUNDT1VOVF9SRUFTT05fSEFURRAFEh4KGlJFUE9SVF9BQ0NPVU5UX1JFQVNPTl9TQ0FNEAYSJAogUkVQT1JUX0FDQ09VTlRfUkVBU09OX0hBUkFTU01FTlQQBxIiCh5SRVBPUlRfQUNDT1VOVF9SRUFTT05fVklPTEVOQ0UQCBIfChtSRVBPUlRfQUNDT1VOVF9SRUFTT05fT1RIRVIQFGIGcHJvdG8z");

/**
 * @generated from message protos.accounts.ReportAccountRequest
 */
export type ReportAccountRequest = Message<"protos.accounts.ReportAccountRequest"> & {
  /**
   * @generated from field: protos.accounts.ReportAccountRequest.Params params = 1;
   */
  params?: ReportAccountRequest_Params | undefined;
};

/**
 * Describes the message protos.accounts.ReportAccountRequest.
 * Use `create(ReportAccountRequestSchema)` to create a new message.
 */
export const ReportAccountRequestSchema: GenMessage<ReportAccountRequest> = /*@__PURE__*/
  messageDesc(file_accounts_report_account, 0);

/**
 * @generated from message protos.accounts.ReportAccountRequest.Params
 */
export type ReportAccountRequest_Params = Message<"protos.accounts.ReportAccountRequest.Params"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: protos.accounts.ReportAccountReason reason = 2;
   */
  reason: ReportAccountReason;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message protos.accounts.ReportAccountRequest.Params.
 * Use `create(ReportAccountRequest_ParamsSchema)` to create a new message.
 */
export const ReportAccountRequest_ParamsSchema: GenMessage<ReportAccountRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_report_account, 0, 0);

/**
 * @generated from message protos.accounts.ReportAccountResponse
 */
export type ReportAccountResponse = Message<"protos.accounts.ReportAccountResponse"> & {
  /**
   * @generated from field: protos.accounts.ReportAccountResponse.Result result = 1;
   */
  result?: ReportAccountResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.ReportAccountResponse.
 * Use `create(ReportAccountResponseSchema)` to create a new message.
 */
export const ReportAccountResponseSchema: GenMessage<ReportAccountResponse> = /*@__PURE__*/
  messageDesc(file_accounts_report_account, 1);

/**
 * @generated from message protos.accounts.ReportAccountResponse.Result
 */
export type ReportAccountResponse_Result = Message<"protos.accounts.ReportAccountResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.ReportAccountResponse.Result.
 * Use `create(ReportAccountResponse_ResultSchema)` to create a new message.
 */
export const ReportAccountResponse_ResultSchema: GenMessage<ReportAccountResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_report_account, 1, 0);

/**
 * @generated from enum protos.accounts.ReportAccountReason
 */
export enum ReportAccountReason {
  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_IMPERSONATION = 1;
   */
  IMPERSONATION = 1,

  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_DISLIKE = 2;
   */
  DISLIKE = 2,

  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_SPAM = 3;
   */
  SPAM = 3,

  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_SEXUAL = 4;
   */
  SEXUAL = 4,

  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_HATE = 5;
   */
  HATE = 5,

  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_SCAM = 6;
   */
  SCAM = 6,

  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_HARASSMENT = 7;
   */
  HARASSMENT = 7,

  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_VIOLENCE = 8;
   */
  VIOLENCE = 8,

  /**
   * @generated from enum value: REPORT_ACCOUNT_REASON_OTHER = 20;
   */
  OTHER = 20,
}

/**
 * Describes the enum protos.accounts.ReportAccountReason.
 */
export const ReportAccountReasonSchema: GenEnum<ReportAccountReason> = /*@__PURE__*/
  enumDesc(file_accounts_report_account, 0);

